import moment from "moment";
import 'moment-timezone';

moment.tz.setDefault("Asia/Almaty");
